import { css, styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

const StyledTypography = styled(Typography, { shouldForwardProp: prop => prop !== 'gutterTop' })<{
  gutterTop: boolean;
}>`
  ${({ gutterTop, theme }) =>
    gutterTop &&
    css`
      margin-top: ${theme.spacing(4)};
    `}
`;

interface SectionTitleProp {
  title: string;
  gutterTop?: boolean;
}

export function SectionTitle(props: SectionTitleProp) {
  const { title, gutterTop = true } = props;

  return (
    <StyledTypography gutterTop={gutterTop} data-test={`${title.toLocaleLowerCase().split(' ')[0]}-title`} variant="h3">
      {title}
    </StyledTypography>
  );
}
